import SetProfile from './SetProfile';
import SetProfileContainer from './SetProfileContainer';

export { SetProfileContainer };
export default SetProfile;



// WEBPACK FOOTER //
// ./src/components/SetProfile/index.js